import { useState, useEffect } from "react";
import AgentsService from "../../services/AgentsService/AgentsService.ts";
import { useAuth } from "../../provider/AuthProvider.tsx";
import SelectGroup from "../../components/Forms/SelectGroup/SelectGroup.tsx";

interface AddAgentPopupProps {
  officeName: string;
  agentsIds: string[];
  onClose: () => void;
  onSave: (selectedAgents: string[]) => void;
}

const AddAgentPopup = ({
  onClose,
  onSave,
  agentsIds,
  officeName,
}: AddAgentPopupProps) => {
  const { jwt } = useAuth();
  const [agents, setAgents] = useState<{ [key: string]: string }>({});
  const [selectedAgent, setSelectedAgent] = useState<string | null>(null);
  const [isFormDisabled, setIsFormDisabled] = useState<boolean>(false);

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const agentsData = await AgentsService.getAllAgents(jwt);
        setAgents(agentsData as { [key: string]: string });
      } catch (error) {
        throw new Error("Грешка при зареждането на агенти", error);
      }
    };
    fetchAgents();
  }, [jwt]);

  const handleSelectedAgent = async (selectedAgent: string) => {
    if (agentsIds.indexOf(selectedAgent) !== -1) {
      setIsFormDisabled(true);
    } else {
      setSelectedAgent(selectedAgent);
      setIsFormDisabled(false);
    }
  };

  const handleSave = () => {
    if (!isFormDisabled) {
      onSave([...agentsIds, selectedAgent]);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 ">
      <div className="dark:bg-boxdark rounded-md bg-white p-6 shadow-lg">
        <h3 className="mb-4 text-xl font-medium text-black dark:text-white">
          Добави агент към {officeName}
        </h3>
        <SelectGroup
          value={selectedAgent || ""}
          placeholder="Изберете агент"
          options={agents}
          onChange={handleSelectedAgent}
        />
        {isFormDisabled && (
          <div className="mb-4 text-rose-500">
            {" "}
            Агентът вече е част от офиса{" "}
          </div>
        )}
        <div className="mt-6 flex justify-end">
          <button className="btn btn-secondary mr-4" onClick={onClose}>
            Отказ
          </button>
          <button
            className={`btn btn-primary ${
              selectedAgent && !isFormDisabled
                ? "bg-primary rounded-md p-2 text-white dark:text-white"
                : "rounded-md bg-stone-500 p-2 text-white dark:text-white"
            }`}
            onClick={handleSave}
            disabled={!selectedAgent || isFormDisabled}
          >
            Запази
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddAgentPopup;
